import React from 'react'
import ReactPlayer from 'react-player'
import { BaseReactPlayerProps } from 'react-player/base'
import ReactVisibilitySensor from 'react-visibility-sensor'

import * as styles from './Video.module.scss'

interface Props {
	m3u8_url: string
	mp4_url: string
	className?: string
	eager?: boolean
	config?: BaseReactPlayerProps
}

const Video = (props: Props) => {
	const [playerVisible, setPlayerVisible] = React.useState(false)
	const [shouldVideoPlay, setShouldVideoPlay] = React.useState(false)
	const [isSafari, setIsSafari] = React.useState(false)

	const PlayerRef = React.useRef(null)
	const videoStyles = [styles.video]

	React.useEffect(() => {
		setIsSafari(/^((?!chrome|android).)*safari/i.test(navigator.userAgent))

		setShouldVideoPlay(true)
	})

	const handleVideoReveal = (isVisible: boolean) => {
		if (isVisible) {
			setPlayerVisible(true)
		}
	}

	let videoConfig: BaseReactPlayerProps = {
		url: props.m3u8_url,
		controls: true,
		config: {
			file: {
				forceHLS: true,
				hlsOptions: { testBandwidth: true, startLevel: -1 },
			},
		},
		onReady: (instance) => {
			const hlsPlayer = instance.getInternalPlayer('hls')

			hlsPlayer.startLoad('startPosition=-1')
		},
	}

	if (props.config) {
		videoConfig = { ...videoConfig, ...props.config }
	}

	if (isSafari) {
		videoConfig.url = props.mp4_url
		videoConfig.config.file.forceHLS = false

		videoConfig.onReady = () => true
	}

	if (props.className) {
		videoStyles.push(props.className)
	}

	const VideoPlayer = () => (
		<div className={videoStyles.join(' ')}>
			<ReactPlayer {...videoConfig} ref={PlayerRef} />
		</div>
	)

	if (props.eager) {
		videoStyles.push(styles.eager)

		return <VideoPlayer />
	} else {
		return (
			<ReactVisibilitySensor partialVisibility={true} onChange={handleVideoReveal}>
				{playerVisible && shouldVideoPlay ? <VideoPlayer /> : <div style={{ minHeight: 100 }}></div>}
			</ReactVisibilitySensor>
		)
	}
}

export default Video
